import n, { useRef as e, useEffect as r } from "react";
import o from "prop-types";
import a from "@leafygreen-ui/box";
import { css as t, cx as l } from "@leafygreen-ui/emotion";
import { useDarkMode as i, useUsingKeyboardContext as c } from "@leafygreen-ui/leafygreen-provider";
import { transparentize as d, mix as g } from "polished";
import { palette as s } from "@leafygreen-ui/palette";
import { fontFamilies as b, typeScales as u, BaseFontSize as p } from "@leafygreen-ui/tokens";
import { Theme as h, createDataProp as f, getTheme as y } from "@leafygreen-ui/lib";
import { registerRipple as x } from "@leafygreen-ui/ripple";

function k(n, e) {
  var r = Object.keys(n);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(n);
    e && (o = o.filter(function (e) {
      return Object.getOwnPropertyDescriptor(n, e).enumerable;
    })), r.push.apply(r, o);
  }

  return r;
}

function m(n) {
  for (var e = 1; e < arguments.length; e++) {
    var r = null != arguments[e] ? arguments[e] : {};
    e % 2 ? k(Object(r), !0).forEach(function (e) {
      w(n, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : k(Object(r)).forEach(function (e) {
      Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return n;
}

function w(n, e, r) {
  return e in n ? Object.defineProperty(n, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = r, n;
}

function v() {
  return v = Object.assign || function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];

      for (var o in r) {
        Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
      }
    }

    return n;
  }, v.apply(this, arguments);
}

function O(n, e) {
  if (null == n) return {};

  var r,
      o,
      a = function (n, e) {
    if (null == n) return {};
    var r,
        o,
        a = {},
        t = Object.keys(n);

    for (o = 0; o < t.length; o++) {
      r = t[o], e.indexOf(r) >= 0 || (a[r] = n[r]);
    }

    return a;
  }(n, e);

  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(n);

    for (o = 0; o < t.length; o++) {
      r = t[o], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(n, r) && (a[r] = n[r]);
    }
  }

  return a;
}

function D(n, e) {
  return e || (e = n.slice(0)), Object.freeze(Object.defineProperties(n, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}

var P,
    j,
    z,
    G,
    B,
    S,
    N,
    M,
    L,
    E,
    q,
    F,
    C,
    I,
    X,
    K,
    H,
    R,
    T,
    Y,
    A,
    J,
    Q,
    U,
    V,
    W,
    Z,
    $,
    _,
    nn,
    en,
    rn,
    on,
    an,
    tn,
    ln,
    cn,
    dn,
    gn,
    sn,
    bn,
    un,
    pn,
    hn,
    fn,
    yn,
    xn,
    kn,
    mn,
    wn,
    vn,
    On,
    Dn = {
  Default: "default",
  Primary: "primary",
  PrimaryOutline: "primaryOutline",
  Danger: "danger",
  DangerOutline: "dangerOutline",
  BaseGreen: "baseGreen"
},
    Pn = {
  XSmall: "xsmall",
  Small: "small",
  Default: "default",
  Large: "large"
},
    jn = {
  Body1: 13,
  Body2: 16
},
    zn = function zn(n) {
  return "\n    0 0 0 2px ".concat(n, ", \n    0 0 0 4px ").concat(s.blue.light1, ";\n");
},
    Gn = t(P || (P = D(["\n  // unset browser default\n  appearance: none;\n  padding: 0;\n  margin: 0;\n  background-color: transparent;\n  border: 1px solid transparent;\n  display: inline-flex;\n  align-items: stretch;\n  transition: all 150ms ease-in-out;\n  position: relative;\n  text-decoration: none;\n  cursor: pointer;\n  z-index: 0;\n  font-family: ", ";\n  border-radius: 6px;\n\n  &:focus {\n    outline: none;\n  }\n\n  &[disabled],\n  &:disabled {\n    pointer-events: none;\n  }\n\n  &:active,\n  &:focus,\n  &:hover {\n    text-decoration: none;\n  }\n"])), b.default),
    Bn = (w(K = {}, h.Light, (w(M = {}, Dn.Default, t(j || (j = D(["\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        box-shadow: 0 0 0 3px ", ";\n      }\n    "])), s.gray.light3, s.gray.base, s.black, s.black, s.white, s.gray.light2)), w(M, Dn.Primary, t(z || (z = D(["\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: #00593f; // Not quite dark3\n        border-color: #00593f; // Not quite dark3\n        box-shadow: 0 0 0 3px ", ";\n      }\n    "])), s.green.dark2, s.green.dark2, s.white, s.white, s.green.light2)), w(M, Dn.PrimaryOutline, t(G || (G = D(["\n      background-color: transparent;\n      border-color: ", ";\n      color: ", ";\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.green.dark2, s.green.dark2, s.green.dark2, d(.96, s.green.base), s.green.light2)), w(M, Dn.Danger, t(B || (B = D(["\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: #c82222; // not quite dark1\n        border-color: #c82222; // not quite dark1\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.red.base, s.red.base, s.white, s.white, s.red.light3)), w(M, Dn.DangerOutline, t(S || (S = D(["\n      background-color: transparent;\n      border-color: ", ";\n      color: ", ";\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.red.light1, s.red.base, s.red.dark2, d(.96, s.red.base), s.red.base, s.red.light3)), w(M, Dn.BaseGreen, t(N || (N = D(["\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.green.base, s.green.dark2, s.green.dark3, s.green.dark3, g(.96, s.green.base, s.green.dark3), s.green.light2)), M)), w(K, h.Dark, (w(X = {}, Dn.Default, t(L || (L = D(["\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        background-color: ", ";\n        border-color: ", ";\n        color: ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.gray.dark2, s.gray.base, s.white, s.white, s.gray.dark1, s.gray.base, s.white, s.gray.dark2)), w(X, Dn.Primary, t(E || (E = D(["\n      background-color: ", ";\n      border: 1px solid ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: #00593f; // Off palette\n        box-shadow: 0 0 0 3px ", ";\n      }\n    "])), s.green.dark2, s.green.base, s.white, s.white, s.white, s.green.dark3)), w(X, Dn.PrimaryOutline, t(q || (q = D(["\n      background-color: transparent;\n      border-color: ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.green.base, s.green.base, s.green.base, s.green.base, d(.96, s.green.base), s.green.base, s.green.dark3)), w(X, Dn.Danger, t(F || (F = D(["\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        border-color: ", ";\n        color: ", ";\n        background-color: #c82222; // Off palette\n        box-shadow: 0px 0px 0px 3px ", "; // yes, yellow\n      }\n    "])), s.red.base, s.red.light1, s.white, s.white, s.red.light1, s.white, s.yellow.dark3)), w(X, Dn.DangerOutline, t(C || (C = D(["\n      border-color: ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        box-shadow: 0px 0px 0px 3px ", "; // yes, yellow\n      }\n    "])), s.red.light1, s.red.light1, s.red.light1, s.red.light1, d(.96, s.red.base), s.yellow.dark3)), w(X, Dn.BaseGreen, t(I || (I = D(["\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.green.base, s.green.dark2, s.green.dark3, s.green.dark3, g(.96, s.green.base, s.green.light3), s.green.dark2, s.green.dark3)), X)), K),
    Sn = (w(en = {}, h.Light, (w(Q = {}, Dn.Default, t(H || (H = D(["\n      &:focus {\n        background-color: ", ";\n        box-shadow: ", ";\n      }\n    "])), s.white, zn(s.white))), w(Q, Dn.Primary, t(R || (R = D(["\n      &:focus {\n        color: ", ";\n        background-color: #00593f; // Not quite dark3\n        box-shadow: ", ";\n      }\n    "])), s.white, zn(s.white))), w(Q, Dn.PrimaryOutline, t(T || (T = D(["\n      &:focus {\n        background-color: ", ";\n        box-shadow: ", ";\n      }\n    "])), d(.96, s.green.base), zn(s.white))), w(Q, Dn.Danger, t(Y || (Y = D(["\n      &:focus {\n        color: ", ";\n        background-color: #c82222; // not quite dark1\n        box-shadow: ", ";\n      }\n    "])), s.white, zn(s.white))), w(Q, Dn.DangerOutline, t(A || (A = D(["\n      &:focus {\n        color: ", ";\n        box-shadow: ", ";\n      }\n    "])), s.red.dark2, zn(s.white))), w(Q, Dn.BaseGreen, t(J || (J = D(["\n      &:focus {\n        box-shadow: ", ";\n      }\n    "])), zn(s.white))), Q)), w(en, h.Dark, (w(nn = {}, Dn.Default, t(U || (U = D(["\n      &:focus {\n        background-color: ", ";\n        box-shadow: ", ";\n      }\n    "])), s.gray.dark1, zn(s.black))), w(nn, Dn.Primary, t(V || (V = D(["\n      &:focus {\n        background-color: #00593f; // Off palette\n        box-shadow: ", ";\n      }\n    "])), zn(s.black))), w(nn, Dn.PrimaryOutline, t(W || (W = D(["\n      &:focus {\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: ", ";\n      }\n    "])), d(.96, s.green.base), s.green.base, zn(s.black))), w(nn, Dn.Danger, t(Z || (Z = D(["\n      &:focus {\n        background-color: #c82222; // Off palette\n        box-shadow: ", ";\n      }\n    "])), zn(s.black))), w(nn, Dn.DangerOutline, t($ || ($ = D(["\n      &:focus {\n        background-color: ", ";\n        border-color: ", ";\n        box-shadow: ", ";\n      }\n    "])), d(.96, s.red.base), s.red.light1, zn(s.black))), w(nn, Dn.BaseGreen, t(_ || (_ = D(["\n      &:focus {\n        background-color: ", ";\n        box-shadow: ", ";\n      }\n    "])), s.green.base, zn(s.black))), nn)), en),
    Nn = (w(an = {}, h.Light, t(rn || (rn = D(["\n    &,\n    &:hover {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n      cursor: not-allowed;\n    }\n\n    &:focus {\n      box-shadow: ", ";\n    }\n  "])), s.gray.light2, s.gray.light1, s.gray.base, zn(s.white))), w(an, h.Dark, t(on || (on = D(["\n    &,\n    &:hover {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n      cursor: not-allowed;\n    }\n\n    &:focus {\n      box-shadow: ", ";\n    }\n  "])), s.gray.dark3, s.gray.dark1, s.gray.dark1, zn(s.black))), an),
    Mn = (w(gn = {}, Pn.XSmall, t(tn || (tn = D(["\n    height: 22px;\n    text-transform: uppercase;\n    font-size: 12px;\n    line-height: 1em;\n    font-weight: bold;\n    letter-spacing: 0.4px;\n  "])))), w(gn, Pn.Small, t(ln || (ln = D(["\n    height: 28px;\n  "])))), w(gn, Pn.Default, t(cn || (cn = D(["\n    height: 36px;\n  "])))), w(gn, Pn.Large, t(dn || (dn = D(["\n    height: 48px;\n    font-size: 18px;\n    line-height: 24px;\n  "])))), gn),
    Ln = (w(un = {}, p.Body1, t(sn || (sn = D(["\n    font-size: ", "px;\n    line-height: ", "px;\n    font-weight: 500; // Medium\n  "])), u.body1.fontSize, u.body1.lineHeight)), w(un, p.Body2, t(bn || (bn = D(["\n    font-size: ", "px;\n    line-height: ", "px;\n    // Pixel pushing for optical alignment purposes\n    transform: translateY(1px);\n    font-weight: 500; // Medium\n  "])), u.body2.fontSize, u.body2.lineHeight)), un),
    En = f("button");

var qn,
    Fn,
    Cn,
    In,
    Xn,
    Kn,
    Hn,
    Rn,
    Tn,
    Yn,
    An,
    Jn,
    Qn,
    Un,
    Vn,
    Wn,
    Zn,
    $n,
    _n,
    ne,
    ee,
    re,
    oe,
    ae,
    te,
    le,
    ie,
    ce,
    de,
    ge,
    se,
    be,
    ue,
    pe,
    he,
    fe,
    ye,
    xe,
    ke,
    me,
    we,
    ve,
    Oe,
    De,
    Pe,
    je = (w(fn = {}, h.Light, (w(pn = {}, Dn.Default, s.gray.light2), w(pn, Dn.Primary, s.green.dark1), w(pn, Dn.PrimaryOutline, d(.76, s.green.base)), w(pn, Dn.Danger, s.red.light1), w(pn, Dn.DangerOutline, d(.76, s.red.base)), w(pn, Dn.BaseGreen, s.green.light1), pn)), w(fn, h.Dark, (w(hn = {}, Dn.Default, s.gray.base), w(hn, Dn.Primary, s.green.dark1), w(hn, Dn.PrimaryOutline, d(.76, s.green.base)), w(hn, Dn.Danger, s.red.dark2), w(hn, Dn.DangerOutline, d(.76, s.red.light1)), w(hn, Dn.BaseGreen, s.green.dark1), hn)), fn),
    ze = t(yn || (yn = D(["\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 5px;\n"]))),
    Ge = t(xn || (xn = D(["\n  display: grid;\n  grid-auto-flow: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  pointer-events: none;\n  position: relative;\n  z-index: 0;\n"]))),
    Be = (w(On = {}, Pn.XSmall, t(kn || (kn = D(["\n    padding: 0 7px; // 8px - 1px border\n    gap: 6px;\n  "])))), w(On, Pn.Small, t(mn || (mn = D(["\n    padding: 0 11px; // 12px - 1px border\n    gap: 6px;\n  "])))), w(On, Pn.Default, t(wn || (wn = D(["\n    padding: 0 11px; // 12px - 1px border\n    gap: 6px;\n  "])))), w(On, Pn.Large, t(vn || (vn = D(["\n    padding: 0 15px; // 16px - 1px border\n    gap: 8px;\n  "])))), On),
    Se = (w(Vn = {}, h.Light, (w(Hn = {}, Dn.Default, t(qn || (qn = D(["\n      color: ", ";\n    "])), s.gray.base)), w(Hn, Dn.Primary, t(Fn || (Fn = D(["\n      color: ", ";\n    "])), s.green.light2)), w(Hn, Dn.PrimaryOutline, t(Cn || (Cn = D(["\n      color: ", ";\n    "])), s.green.dark2)), w(Hn, Dn.Danger, t(In || (In = D(["\n      color: ", ";\n    "])), s.red.light3)), w(Hn, Dn.DangerOutline, t(Xn || (Xn = D(["\n      color: ", ";\n    "])), s.red.light1)), w(Hn, Dn.BaseGreen, t(Kn || (Kn = D(["\n      color: ", ";\n    "])), s.green.dark2)), Hn)), w(Vn, h.Dark, (w(Un = {}, Dn.Default, t(Rn || (Rn = D(["\n      color: ", ";\n    "])), s.gray.light2)), w(Un, Dn.Primary, t(Tn || (Tn = D(["\n      color: ", ";\n    "])), s.green.light2)), w(Un, Dn.PrimaryOutline, t(Yn || (Yn = D(["\n      color: ", ";\n    "])), s.green.base)), w(Un, Dn.Danger, t(An || (An = D(["\n      color: ", ";\n    "])), s.red.light2)), w(Un, Dn.DangerOutline, t(Jn || (Jn = D(["\n      color: ", ";\n    "])), s.red.light1)), w(Un, Dn.BaseGreen, t(Qn || (Qn = D(["\n      color: ", ";\n    "])), s.green.dark2)), Un)), Vn),
    Ne = (w(ge = {}, h.Light, (w(re = {}, Dn.Default, t(Wn || (Wn = D(["\n      color: ", ";\n    "])), s.black)), w(re, Dn.Primary, t(Zn || (Zn = D(["\n      color: ", ";\n    "])), s.white)), w(re, Dn.PrimaryOutline, t($n || ($n = D(["\n      color: ", ";\n    "])), s.green.dark2)), w(re, Dn.Danger, t(_n || (_n = D(["\n      color: ", ";\n    "])), s.white)), w(re, Dn.DangerOutline, t(ne || (ne = D(["\n      color: ", ";\n    "])), s.red.base)), w(re, Dn.BaseGreen, t(ee || (ee = D(["\n      color: ", ";\n    "])), s.green.dark3)), re)), w(ge, h.Dark, (w(de = {}, Dn.Default, t(oe || (oe = D(["\n      color: ", ";\n    "])), s.white)), w(de, Dn.Primary, t(ae || (ae = D(["\n      color: ", ";\n    "])), s.white)), w(de, Dn.PrimaryOutline, t(te || (te = D(["\n      color: ", ";\n    "])), s.green.base)), w(de, Dn.Danger, t(le || (le = D(["\n      color: ", ";\n    "])), s.white)), w(de, Dn.DangerOutline, t(ie || (ie = D(["\n      color: ", ";\n    "])), s.red.light1)), w(de, Dn.BaseGreen, t(ce || (ce = D(["\n      color: ", ";\n    "])), s.green.dark3)), de)), ge),
    Me = t(se || (se = D(["\n  ", ":hover &,\n  ", ":active & {\n    color: currentColor;\n  } ;\n"])), En.selector, En.selector),
    Le = (w(fe = {}, Pn.XSmall, t(be || (be = D(["\n    height: 14px;\n    width: 14px;\n  "])))), w(fe, Pn.Small, t(ue || (ue = D(["\n    height: 16px;\n    width: 16px;\n  "])))), w(fe, Pn.Default, t(pe || (pe = D(["\n    height: 16px;\n    width: 16px;\n  "])))), w(fe, Pn.Large, t(he || (he = D(["\n    height: 20px;\n    width: 20px;\n  "])))), fe),
    Ee = (w(ke = {}, h.Light, t(ye || (ye = D(["\n    color: ", ";\n  "])), s.gray.light1)), w(ke, h.Dark, t(xe || (xe = D(["\n    color: ", ";\n  "])), s.gray.dark1)), ke),
    qe = (w(ve = {}, h.Light, t(me || (me = D(["\n    color: ", ";\n  "])), s.gray.light1)), w(ve, h.Dark, t(we || (we = D(["\n    color: ", ";\n  "])), s.gray.dark2)), ve);

function Fe(e) {
  var r,
      o = e.glyph,
      a = e.variant,
      t = e.size,
      i = e.darkMode,
      c = e.disabled,
      d = e.isIconOnlyButton,
      g = e.className,
      s = !d && {
    "aria-hidden": !0,
    role: "presentation"
  },
      b = y(i),
      u = d ? Ne : Se;
  return n.cloneElement(o, m({
    className: l(u[b][a], Le[t], (r = {}, w(r, Ee[b], c), w(r, Me, d), w(r, qe[b], c && d), r), g)
  }, s));
}

Fe.displayName = "ButtonIcon";

var Ce = function Ce(o) {
  var a,
      c = o.rightGlyph,
      d = o.leftGlyph,
      g = o.darkMode,
      s = o.disabled,
      b = void 0 !== s && s,
      u = o.variant,
      p = void 0 === u ? Dn.Default : u,
      h = o.size,
      f = void 0 === h ? Pn.Default : h,
      y = o.children,
      k = i(g),
      m = k.darkMode,
      O = k.theme,
      P = e(null);
  r(function () {
    var n,
        e = je[O][p];
    return null == P.current || b || (n = x(P.current, {
      backgroundColor: e
    })), n;
  }, [P, p, m, b, O]);
  var j = null !== (a = (d || c) && !y) && void 0 !== a && a,
      z = {
    variant: p,
    size: f,
    darkMode: m,
    disabled: b,
    isIconOnlyButton: j
  };
  return n.createElement(n.Fragment, null, n.createElement("div", {
    className: l(ze),
    ref: P
  }), n.createElement("div", {
    className: l(Ge, Be[f], w({}, t(Oe || (Oe = D(["\n            justify-content: space-between;\n          "]))), !!c && m))
  }, d && n.createElement(Fe, v({
    glyph: d,
    className: t(De || (De = D(["\n              justify-self: right;\n            "])))
  }, z)), y, c && n.createElement(Fe, v({
    glyph: c,
    className: t(Pe || (Pe = D(["\n              justify-self: left;\n            "])))
  }, z))));
},
    Ie = ["variant", "size", "darkMode", "baseFontSize", "disabled", "onClick", "leftGlyph", "rightGlyph", "children", "className", "as", "type"],
    Xe = n.forwardRef(function (e, r) {
  var o = e.variant,
      t = void 0 === o ? Dn.Default : o,
      d = e.size,
      g = void 0 === d ? Pn.Default : d,
      s = e.darkMode,
      b = e.baseFontSize,
      u = void 0 === b ? p.Body1 : b,
      h = e.disabled,
      f = void 0 !== h && h,
      x = e.onClick,
      k = e.leftGlyph,
      v = e.rightGlyph,
      D = e.children,
      P = e.className,
      j = e.as,
      z = e.type,
      G = O(e, Ie),
      B = c().usingKeyboard,
      S = i(s).darkMode,
      N = function (n) {
    var e = n.variant,
        r = n.size,
        o = n.darkMode,
        a = n.baseFontSize,
        t = n.disabled,
        i = n.usingKeyboard,
        c = y(o),
        d = Bn[c][e],
        g = Sn[c][e];
    return l(Gn, d, Ln[a], Mn[r], w({}, g, i && !t), w({}, Nn[c], t));
  }({
    variant: t,
    size: g,
    darkMode: S,
    baseFontSize: u,
    disabled: f,
    usingKeyboard: B
  }),
      M = !(!G.href && "a" !== j || f),
      L = m(m(m({
    type: M ? void 0 : z || "button",
    className: l(N, P),
    ref: r,
    as: j || (M ? "a" : "button")
  }, "string" != typeof G.href && {
    disabled: f
  }), {}, {
    "aria-disabled": f,
    onClick: f ? void 0 : x
  }, En.prop), G),
      E = {
    rightGlyph: v,
    leftGlyph: k,
    darkMode: S,
    disabled: f,
    variant: t,
    size: g
  };

  return n.createElement(a, L, n.createElement(Ce, E, D));
});

Xe.displayName = "Button", Xe.propTypes = {
  variant: o.oneOf(Object.values(Dn)),
  baseFontSize: o.oneOf(Object.values(p)),
  size: o.oneOf(Object.values(Pn)),
  darkMode: o.bool,
  disabled: o.bool,
  leftGlyph: o.element,
  rightGlyph: o.element,
  href: o.string
};
export { jn as FontSize, Pn as Size, Dn as Variant, Xe as default };